import PeopleIcon from '@mui/icons-material/People'
import QueryStatsIcon from '@mui/icons-material/QueryStats'

export const routeFrontOfficeSchoolGroupementChainCommon = [
  {
    route: 'Participants',
    text: 'Les participants',
    t: 'routes.backoffice.school.industry.participants',
    href: '/backoffice/school/participants',
    icon: PeopleIcon,
    menuHeader: true,
    position: 500,
  },
  {
    // Espace Pharmedigroup (pas de `space`) : la page parle du parc du groupement. L'API seule sait si
    // l'écran a un objet : un groupement français, le module ouvert, une pharmacie en formation.
    route: 'SchoolGroupementTracking',
    text: 'Suivi des formations',
    t: 'routes.frontoffice.groupement.schoolTracking',
    href: '/industryoffice/groupement-chain/school-tracking',
    icon: QueryStatsIcon,
    menuHeader: true,
    position: 490,
    fnDisplay: ({ menuBadges }: { menuBadges?: { schoolGroupementTracking?: boolean | null } }) =>
      menuBadges?.schoolGroupementTracking === true,
  },
]
